import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { ProofSection } from '../components/ProofSection';
import { LearnSection } from '../components/LearnSection';
import { ProgramDetails } from '../components/ProgramDetails';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { MentorSection } from '../components/MentorSection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { BeforeSection } from '../components/BeforeSection';
import { AfterSection } from '../components/AfterSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { BonusSection } from '../components/BonusSection';
import { FaqAccordion } from '../components/FaqAccordion';
import { CostOfInactionSection } from '../components/CostOfInactionSection';
import { CommunitySection } from '../components/CommunitySection';
import { TrustSection } from '../components/TrustSection';
import { UrgencyScarcitySection } from '../components/UrgencyScarcitySection';
import { FinalMentorSection } from '../components/FinalMentorSection';
import { Footer } from '../components/Footer';
import { StickyRibbon } from '../components/StickyRibbon';
export function LandingPage() {
  return <div className="w-full min-h-screen flex justify-center bg-brand-navy" data-id="element-531">
      <StickyRibbon data-id="element-532" />
      {/* Main Container */}
      <main className="w-full bg-[#FCFBFA] relative overflow-x-hidden pt-[60px] md:pt-[80px]" data-id="element-533">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-[800px] bg-gradient-to-b from-brand-cream/80 via-[#D98BAF]/10 to-transparent pointer-events-none z-0" data-id="element-534"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-lavender/30 rounded-full blur-[120px] pointer-events-none z-0 translate-x-1/3 -translate-y-1/4" data-id="element-535"></div>

        <HeroSection data-id="element-536" />
        <IntroSection data-id="element-537" />
        <ProofSection data-id="element-538" />
        <LearnSection data-id="element-539" />
        <ProgramDetails data-id="element-540" />
        <WhoIsThisForSection data-id="element-541" />
        <MentorSection data-id="element-542" />
        <PortfolioCarousel data-id="element-543" />
        <BeforeSection data-id="element-544" />
        <AfterSection data-id="element-545" />
        <TestimonialsSection data-id="element-546" />
        <BonusSection data-id="element-547" />
        <ModulesSection data-id="element-548" />
        <TrustSection data-id="element-549" />
        <CommunitySection data-id="element-550" />
        <UrgencyScarcitySection data-id="element-551" />
        <PricingSection data-id="element-552" />
        <FinalMentorSection data-id="element-553" />
        <CostOfInactionSection data-id="element-554" />
        <FaqAccordion data-id="element-555" />
        <Footer data-id="element-556" />
      </main>
    </div>;
}